import { onActivated, onDeactivated, ref } from 'vue';

export function useIsActivated() {
    const isVisible = ref(true);
    onActivated(() => {
        isVisible.value = true;
    });

    onDeactivated(() => {
        isVisible.value = false;
    });
    return isVisible;
}
